import { ReebeloStoreT } from '@lambda/reebelo';

export type DropdownProps = {
  options: { label: string; value: string }[];
  name: string;
  className?: string;
  label: string;
  value: string;
  setValue: (value: string) => void;
  placeholder?: string;
  autoComplete?: string;
  required: boolean;
  disabled: boolean;
};

export type InputProps = {
  type: string;
  name: string;
  placeholder: string;
  className?: string;
  label?: string;
  value: string | undefined;
  setValue: (value: string) => void;
  autoComplete?: string;
  disabled: boolean;
  required: boolean;
};

export type PhoneInputProps = {
  className?: string;
  setValue: (value: string) => void;
  value: string | undefined;
  required?: boolean;
  label: string;
  placeholder: string;
  disabled: boolean;
  name: string;
  countryCode: string;
};

export type FormField = {
  label: string;
  placeholder: string;
  disabled: boolean;
  required: boolean;
  initialValue: string;
  hidden: boolean;
};

export enum FieldNames {
  ADDRESS1 = 'address1',
  ADDRESS2 = 'address2',
  CITY = 'city',
  STATE = 'state',
  POSTAL_CODE = 'postalCode',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  PHONE = 'phone',
}

export type FormSchema = Partial<{
  [S in ReebeloStoreT]: {
    [fieldName in FieldNames]: FormField;
  };
}>;
